import mimetypes from "mime-types";

export const isImage = (fileExt: string) => {
  const type = mimetypes.lookup(fileExt) || "";
  return type?.startsWith("image/") || false;
};

export const isVideo = (fileExt: string) => {
  const type = mimetypes.lookup(fileExt) || "";
  return type?.startsWith("video/") || false;
};

export const isAudio = (fileExt: string) => {
  const type = mimetypes.lookup(fileExt) || "";
  return type?.startsWith("audio/") || false;
};

export const isWord = (fileExt: string) => {
  return fileExt?.toLowerCase().startsWith("doc");
};

export const isPowerpoint = (fileExt: string) => {
  return fileExt?.toLowerCase().startsWith("ppt");
};

export const isExcel = (fileExt: string) => {
  return fileExt?.toLowerCase().startsWith("xls");
};

export const isPDF = (fileExt: string) => {
  return fileExt?.toLowerCase() == "pdf";
};

export const getOfficeMimeTypes = () => {
  const officeExtensions = [".doc", ".docx", ".ppt", ".pptx", ".xls", ".xlsx"];
  const mimeTypes = officeExtensions.map((ext) => {
    return mimetypes.lookup(ext) || "";
  });
  return Array.from(new Set(mimeTypes.filter(Boolean)));
};
